import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useDispatch, useSelector } from 'react-redux';
import { getLatLong, useGetPhysicianLocationQuery } from '../../../redux/slices/physician/physicianThunk';
import { setLocations } from '../../../redux/slices/physician/physicianSlice';
import { useUpdateDocLocationMutation } from '../../../redux/slices/physician/physicianThunk';

const GoogleMapsAutocomplete = () => {
    const dispatch = useDispatch();

    // const docLocations = useSelector(state => state.physician.location);
    const [ updateDocLocation ] = useUpdateDocLocationMutation();
    const { locations: docLocations } = useSelector(state => state.physician);

    const [options, setOptions] = useState([]);

    const handleInputChange = (event, value) => {
        if (!value) {
            setOptions([]);
            return;
        }

        const autocompleteService = new window.google.maps.places.AutocompleteService();
        autocompleteService.getPlacePredictions(
            { input: value },
            (results, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                setOptions(results || []);
                }
            }
        );
    };

    const handleSelect = async (e, locations) => {
        e.preventDefault();
        console.log(JSON.stringify(docLocations));
        //find out if a location was added or removed
        const newLocation = locations.filter(location => !docLocations.includes(location));
        const removedLocation = docLocations.filter(location => !locations.includes(location));
        console.log(newLocation);
        console.log(removedLocation);

        let address;
        let type;
        let latLong;
        if(newLocation.length > 0) {
            address = newLocation[0].description;
            type = "add";
            latLong = await dispatch(getLatLong({location: address})).unwrap();
        } else if(removedLocation.length > 0) {
            address = removedLocation[0].address;
            type = "remove";
        }
        console.log(latLong)
        const location = {
            address: address,
            latitude: latLong?.lat,
            longitude: latLong?.lng
        }
        dispatch(setLocations([...locations]));
        try {
            console.log(location, type)
            await updateDocLocation({ location, type }).unwrap();
        } catch(e) {
            console.log(e);
        }
    };

    return (
            <Autocomplete
                id="locations"
                options={options}
                multiple={true}
                getOptionLabel={(option) =>
                    option.description ? option.description : option.address ? option.address : ''
                }
                onChange={handleSelect}
                onInputChange={handleInputChange}
                defaultValue={docLocations}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Locations"
                        variant="filled"
                        fullWidth
                        sx={{ maxHeight: "30rem", 
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none", // Removes the outer border
                            },
                            "& .MuiOutlinedInput-root": {
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none", // Ensures no border on hover
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    border: "none", // Ensures no border when focused
                                },
                            },
                    }}/>
                )}
                renderOption={(props, option) => (
                    <li {...props}>
                        <LocationOnIcon />
                        {option.description}
                    </li>
                )}
                sx={{ 
                    width: '80%',
                    border: "1px solid #D9D9D9",
                    borderRadius: "0.5rem",
                    "& .MuiInputBase-root": {
                        overflow: "auto",
                        border: "none"
                    },
                    "& .MuiAutocomplete-endAdornment": {
                        display: "none",
                    },
                    "& .MuiFilledInput-root:before": {
                        border: "none",
                    },
                    "& .MuiFilledInput-root:after": {
                        border: "none",
                    },
            }}/>
    );
};

export default GoogleMapsAutocomplete;